import UserDevices from "./user-devices";

export default UserDevices